/* unplugin-vue-components disabled */import script from "./getQuote.vue?vue&type=script&setup=true&lang=js"
export * from "./getQuote.vue?vue&type=script&setup=true&lang=js"

import "./getQuote.vue?vue&type=style&index=0&id=6239859e&scoped=true&lang=scss"

import exportComponent from "D:\\00JH-项目\\钧舵机器人\\cn\\jodell_robotics\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6239859e"]])

export default __exports__